<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.treatment') }}
    </p>
    <VTextField
      v-model="data.treatment"
      outlined
      :label="$t('forms.labels.treatment')"
      :rules="{ required: true, min: 1, max: 200 }"
      data-cy="cyArTreatment"
    />
    <VTextField
      v-model="data.biocideInfo"
      outlined
      :label="$t('forms.labels.biocideInfo')"
      :rules="{ required: true, min: 1, max: 1000 }"
      data-cy="biocideInfo"
    />
    <v-row>
      <v-col>
        <VTextField
          v-model="data.temperature"
          outlined
          :label="$t('forms.labels.temperature')"
          :rules="{ decimal: 2, required: !isTemplate }"
          data-cy="temperatureForAR"
        />
      </v-col>
      <v-col>
        <VSelect
          v-model="data.temperatureUnit"
          :label="$t('forms.labels.units')"
          :items="tempratureUnits"
          :required="!isTemplate"
          :validateAtInitialization="data.temperatureUnit !== ''"
          itemValue="key"
          outlined
          data-cy="temperatureUnitForAR"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';


export default {
    components: {
        VTextField,
        VSelect,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
        isTemplate: {
            type: Boolean,
            default: false,
        },
        tempratureUnits: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            data: {
                biocideInfo: this.analysisRequest.biocideInfo,
                temperature: this.analysisRequest.temperature,
                temperatureUnit: this.analysisRequest.temperatureUnit,
                treatment: this.analysisRequest.treatment,
            },
        };
    },
    watch: {
        data: {
            handler() {
                this.$emit('updateData', this.data);
            },
            deep: true,
        },
    },
};
</script>
